import { render, staticRenderFns } from "./GeneralPayrollDetailList.vue?vue&type=template&id=fdadb3f6&scoped=true&"
import script from "./GeneralPayrollDetailList.vue?vue&type=script&lang=ts&"
export * from "./GeneralPayrollDetailList.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralPayrollDetailList.vue?vue&type=style&index=0&id=fdadb3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdadb3f6",
  null
  
)

export default component.exports